import {PuiSimpleReferentielField} from "@portnet/ui";
import React from "react";

const AppSimpleReferentielField = React.forwardRef((props, ref) => {
  return <PuiSimpleReferentielField ref={ref} {...props} />;
});

export default AppSimpleReferentielField;
